'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    navClassNames: function() {
        return navClassNames;
    },
    useNavStyles_unstable: function() {
        return useNavStyles_unstable;
    }
});
const _react = require("@griffel/react");
const navClassNames = {
    root: 'fui-Nav'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f22iagw",
        Beiy3e4: "f1vx9l62"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f1vx9l62{flex-direction:column;}"
    ]
});
const useNavStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(navClassNames.root, styles.root, state.root.className);
    // TODO Add class names to slots, for example:
    // state.mySlot.className = mergeClasses(styles.mySlot, state.mySlot.className);
    return state;
};
